class MainBrands extends HTMLElement {
  constructor() {
    super();
    this.searchInput = this.querySelector('#brand-search');
    this.featuredBrandsContainer = this.querySelector('.main-brands__featured-brands-hld');
    this.featuredItems = Array.from(this.querySelectorAll('.main-brands__featured-brands-item'));
    this.listContainer = this.querySelector('.main-brands__list');
    this.listRows = Array.from(this.querySelectorAll('.main-brands__list-row'));
    this.listItems = Array.from(this.querySelectorAll('.main-brands__list-item'));
    
    this.initSearch();
  }

  initSearch() {
    const searchList = [
      // Regular brand items
      ...this.listItems.map(item => ({
        name: item.textContent.trim(),
        element: item,
        row: item.closest('.main-brands__list-row'),
        type: 'regular'
      })),
      // Featured brand items
      ...this.featuredItems.map(item => ({
        name: item.querySelector('img')?.alt || item.textContent.trim(),
        element: item,
        section: item.closest('.main-brands__featured-brands-list'),
        type: 'featured'
      }))
    ];

    // Initialize Fuse with proper configuration
    this.fuse = new Fuse(searchList, {
      keys: ['name'],
      threshold: 0.4, // matching strength
      minMatchCharLength: 1,
      ignoreDiacritics: true,
      ignoreLocation: true // Makes fuzzy search more flexible
    });

    // Create no results element if it doesn't exist
    if (!this.noResultsElement) {
      this.noResultsElement = document.createElement('div');
      this.noResultsElement.className = 'main-brands__no-results';
      this.noResultsElement.textContent = this.listContainer.getAttribute('data-no-results');
      this.noResultsElement.style.display = 'none';
      this.listContainer.appendChild(this.noResultsElement);
    }

    // Add search input event listener with debounce
    let timeout;
    this.searchInput.addEventListener('input', (event) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => this.handleSearch(event), 300);
    });
  }

  handleSearch(event) {
    const searchTerm = event.target.value.trim();

    if (!searchTerm) {
      // Show all items if search is empty
      this.listItems.forEach(item => item.style.display = '');
      this.listRows.forEach(row => row.style.display = '');
      this.featuredItems.forEach(item => item.style.display = '');
      if (this.featuredBrandsContainer) {
        this.featuredBrandsContainer.style.display = '';
      }
      this.noResultsElement.style.display = 'none';
      return;
    }

    // Hide all items first
    this.listItems.forEach(item => item.style.display = 'none');
    this.listRows.forEach(row => row.style.display = 'none');
    this.featuredItems.forEach(item => item.style.display = 'none');
    if (this.featuredBrandsContainer) {
      this.featuredBrandsContainer.style.display = 'none';
    }

    // Perform fuzzy search
    const results = this.fuse.search(searchTerm);

    if (results.length === 0) {
      this.noResultsElement.style.display = 'block';
      return;
    }

    // Show matched items and their containers
    this.noResultsElement.style.display = 'none';
    const matchedRows = new Set();
    const matchedFeaturedSections = new Set();
    let hasFeaturedResults = false;

    results.forEach(({ item }) => {
      item.element.style.display = '';
      if (item.type === 'regular') {
        matchedRows.add(item.row);
      } else if (item.type === 'featured') {
        hasFeaturedResults = true;
        matchedFeaturedSections.add(item.section);
      }
    });

    // Show containers of matched items
    matchedRows.forEach(row => {
      row.style.display = '';
    });

    if (hasFeaturedResults && this.featuredBrandsContainer) {
      this.featuredBrandsContainer.style.display = '';
      matchedFeaturedSections.forEach(section => {
        if (section) {
          section.style.display = '';
        }
      });
    }
  }
}

customElements.define('main-brands', MainBrands); 